
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AccountingDocumentTypeEnum } from '@gid/models';
import PaymentAmount from './PaymentAmount.vue';
@Component({
  components: {
    PaymentAmount,
  },
})
export default class DocumentLabel extends Vue {
  @Prop({ required: true }) document!: any;
  @Prop() newStatus!: string;
  @Prop() documentLink!: boolean;
  /**
   * When true, render the label for the cancellation side of the document:
   * show cancellationNumber, cancellationDate, cancellationStatus, and an
   * inverted amount sign. Used by the payment reconciliation modal when a
   * document is selected via its cancellation number.
   */
  @Prop({ default: false }) reconcileCancellation!: boolean;

  get activeNumber(): string {
    return this.reconcileCancellation && this.document.cancellationNumber
      ? this.document.cancellationNumber
      : this.document.number;
  }
  get activePath(): string | undefined {
    return this.reconcileCancellation && this.document.cancellationPath
      ? this.document.cancellationPath
      : this.document.path;
  }
  get issueDate(): string {
    return this.reconcileCancellation && this.document.cancellationDate
      ? this.document.cancellationDate
      : this.document.issueDate;
  }
  get signedAmount(): number {
    const gross = this.document.totalAmount + (this.document.vatAmount || 0);
    // Cancellation inverts the sign relative to the original document.
    return gross * (this.reconcileCancellation ? -1 : 1);
  }
}
